/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const LOCATIONS_ADD_REQUEST = 'LOCATIONS_ADD_REQUEST';
export const LOCATIONS_ADD_REQUEST_SUCCESS = 'LOCATIONS_ADD_REQUEST_SUCCESS';
export const LOCATIONS_ADD_REQUEST_FAILURE = 'LOCATIONS_ADD_REQUEST_FAILURE';

export const LOCATIONS_FETCH_REQUEST = 'LOCATIONS_FETCH_REQUEST';
export const LOCATIONS_FETCH_REQUEST_SUCCESS = 'LOCATIONS_FETCH_REQUEST_SUCCESS';
export const LOCATIONS_FETCH_REQUEST_FAILURE = 'LOCATIONS_FETCH_REQUEST_FAILURE';

export const LOCATIONS_UPSERT_REQUEST = 'LOCATIONS_UPSERT_REQUEST';
export const LOCATIONS_UPSERT_REQUEST_SUCCESS = 'LOCATIONS_UPSERT_REQUEST_SUCCESS';
export const LOCATIONS_UPSERT_REQUEST_FAILURE = 'LOCATIONS_UPSERT_REQUEST_FAILURE';

export const LOCATIONS_DELETE_REQUEST = 'LOCATIONS_DELETE_REQUEST';
export const LOCATIONS_DELETE_REQUEST_SUCCESS = 'LOCATIONS_DELETE_REQUEST_SUCCESS';
export const LOCATIONS_DELETE_REQUEST_FAILURE = 'LOCATIONS_DELETE_REQUEST_FAILURE';

export const LOCATIONS_FETCH_DROPDOWN_REQUEST = 'LOCATIONS_FETCH_DROPDOWN_REQUEST';
export const LOCATIONS_FETCH_DROPDOWN_REQUEST_SUCCESS = 'LOCATIONS_FETCH_DROPDOWN_REQUEST_SUCCESS';
export const LOCATIONS_FETCH_DROPDOWN_REQUEST_FAILURE = 'LOCATIONS_FETCH_DROPDOWN_REQUEST_FAILURE';

export const LOCATIONS_CLEAN_REQUEST = 'LOCATIONS_CLEAN_REQUEST';
